module.exports = __webpack_public_path__ + "components/outside-promo-page/static/surfers-8ee5f319de595c71d2f91d642cfe83f2.webp";